import { differenceInDays, toDate } from 'date-fns';
import { connect } from 'react-redux';

import { ResizeProps } from 'src/components/sidebar';
import {
  isSourceSidebarOpen,
  updateSidebarState,
  getSourceSidebarWidth,
} from 'src/redux/sidebar';
import { getIsMobileHeaderActive } from 'src/selectors/global-selectors';
import { getCurrentUser } from 'src/selectors/user-selectors';
import { BucketDispatch, BucketState } from 'src/types/state';

import SourceSidebar from '../components/sidebar';
import { NEW_USER_EXPERIMENT_AGE_IN_DAYS } from '../constants';

const mapStateToProps = (state: BucketState) => {
  const user = getCurrentUser(state);
  const createdOn = user && user.created_on ? user.created_on : null;

  return {
    isCollapsed: getIsMobileHeaderActive(state)
      ? false
      : !isSourceSidebarOpen(state),
    expandedWidth: getSourceSidebarWidth(state),
    isNewUser: createdOn
      ? differenceInDays(toDate(Date.now()), toDate(new Date(createdOn))) <
        NEW_USER_EXPERIMENT_AGE_IN_DAYS
      : false,
  };
};

const mapDispatchToProps = (dispatch: BucketDispatch) => ({
  onResize: (resizeProps: ResizeProps) =>
    dispatch(
      updateSidebarState({
        isOpen: !resizeProps.isCollapsed,
        width: resizeProps.width,
        sidebarType: 'source',
      })
    ),
  toggleSidebar: () => dispatch(updateSidebarState({ sidebarType: 'source' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SourceSidebar);
